import React, { useEffect, useState } from "react";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { getBackDropClose } from '../../../features/messageInfo';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function SimpleBackdrop() {
    const classes = useStyles();
    const backDropClose = useSelector(getBackDropClose);

    return (
        <Backdrop className={classes.backdrop} open={backDropClose}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}
